export default __webpack_public_path__ + "static/media/dotFind.90bcfcaa.svg";